import {Injectable} from '@angular/core';
import {formatISO} from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  constructor() {
  }

  handleCognitoError = (error: any) => {
    let header, message;
    switch (error?.__type) {
      case 'UsernameExistsException':
        header = `ERROR: Username`;
        message = error.message;
        break;
      case 'NotAuthorizedException':
        header = `ERROR: Login`;
        message = error.message;
        break;
      case 'InvalidParameterException':
        header = 'ERROR: Invalid Parameter';
        message = error.message;
        break;
      case 'InvalidPasswordException':
        header = 'ERROR: Password';
        message = error.message;
        break;
      case 'UserNotFoundException':
        header = 'ERROR: Account';
        message = error.message + " redirecting you to login page.";
        break;
      default:
        header = 'ERROR: Oooops.';
        message = "Internal server error. Please try again later.";
        break;
    }
    return {
      timestamp: formatISO(new Date()),
      status: error.status,
      header,
      message,
    }
  };
}
